/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */

import { useState, useEffect } from "react";
// import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getAllReferrals, getAllUser, getAllOfferCodes, getAllAffiliates, addAffiliate, getAllCustomPlans, addCustomPlan, addOfferCode, getPlanFeatures } from '../../../redux/action/admin';
import STable from '../../modules/cardform/components/helpers/STable';
import Modal from 'react-bootstrap/Modal'
import { validateEmail } from '../../../_4threal/helpers' //validateLink, validatePhone, AppLog
import { generatePopup } from '../../../utils/popup'
import Checkbox from '../../modules/cardform/components/helpers/Checkbox'
import QRCodeStyling from "qr-code-styling";
import { mimicLogin } from '../../../redux/action/auth'
import B2BAccountsTable from './components/B2BAccountsTable'
import { adminSwitchToAccount } from "../../../redux/action/account";
// import timeSince from '../../../utils/timesince';

function Admintools() {
  const ngrokip:any = process.env.REACT_APP_NGROK_FRONTEND_URL;
  const testmode = localStorage.getItem('testmode')
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [currQR, setCurrQr] = useState('');
  const referrals: any = useSelector((state: any) => state.Admin?.AllReferrals)
  // const token = localStorage.getItem('userId') //omitting due to eslint warning
  // const [dataMyTable, setdataMyTable] = useState<any>([]);
   const users: any = useSelector((state: any) => state.Admin?.AllUser)
   const offerCodes: any = useSelector((state: any) => state.Admin?.AllOfferCodes)
   const affiliates: any = useSelector((state: any) => state.Admin?.AllAffiliates)
   const customPlansRaw: any = useSelector((state: any) => state.Admin?.AllCustomPlans) || []
   const planFeatures: any = useSelector((state: any) => state.Admin?.planFeatures) || {}
   
   // Transform custom plans to use taglines for display
   const customPlans = customPlansRaw.map((plan: any) => ({
     ...plan,
     planFeatures: plan.taglines && plan.taglines.length > 0 
       ? plan.taglines.join(', ') 
       : 'None'
   }))

  //  const [offerCodesParsed, setOfferCodesParsed] = useState([]);
  //  const [limitRedemptions, setLimitRedemptions] = useState(false);
  //  const [limitStartDate, setLimitStartDate] = useState(false); //omitting due to eslint
   const [limitEndDate, setLimitEndDate] = useState(false);
   const [productDiscountType, setProductDiscountType] = useState("percentage");
   const [subscriptionDiscountType, setSubscriptionDiscountType] = useState("percentage");
  const [affiliateCommissionType, setAffiliateCommissionType] = useState("percentage");
   const [modalType, setModalType] = useState('')
   const handleClose = () => {
     setModalType('')
     // Reset form fields when closing modal
     setReferralFields({
       firstName: '',
       lastName: '',
       offer_code: 'beta',
       email: ''
     })
     setAffiliateFields({
       affiliateName: '',
       email: '',
       offerCode: '',
       customPlans: [],
       includeStandardPlans: true,
       commissionRate: 0,
       commissionIsPercent: true
     })
     setOfferCodeFields({
       id: '',
       max_redemptions: 0,
       allow_in_checkout: false,
       product_discount: 0,
       product_discount_is_percent: true,
       subscription_discount: 0,
       subscription_discount_is_percent: true,
       valid_start:0,
       valid_end:0,
       cycles:0,
       trial_days:0,
       is_live: true,
     })
     setGeneratedAffiliateLink('')
     setReferralErrors({
       firstName: false,
       lastName: false,
       email: false
     })
     setAffiliateErrors({
       affiliateName: false,
       email: false
     })
     setPlanFields({
       planName: '',
       planDescription: '',
       planFeatures: [],
       monthlyPrice: 0,
       yearlyPrice: 0,
     })
     setPlanErrors({
       planName: false,
       planDescription: false,
       monthlyPrice: false
     })
     setIsCreatingPlan(false)
     setIsCreatingOfferCode(false)
     setIsCreatingAffiliate(false)
   }
   const [referralFields, setReferralFields] = useState<any>({
    firstName: '',
    lastName: '',
    offer_code: 'beta',
    email: ''
  })

  const [affiliateFields, setAffiliateFields] = useState<any>({
    affiliateName: '',
    email: '',
    offerCode: '',
    customPlans: [], // Array of selected custom plan IDs
    includeStandardPlans: true, // Switch for standard plans
    commissionRate: 0,
    commissionIsPercent: true // true for percentage, false for flat amount
  })



  const millistoDate = (millis: number) => {
    const date = new Date(millis);
    return date.toISOString();
  }

  const millistoDatetimeLocal = (millis: number) => {
    const date = new Date(millis);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Combine into the required format for datetime-local
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const makeQrcode = (url) => {
    return new Promise(async (resolve, reject) => {
      try {


        const qrCode = new QRCodeStyling({
          "type": "svg",
          "shape": "square",
          "width": 250,
          "height": 250,
          "data": url,
          "margin": 8,
          "image": '/media/logos/xrlogosq.svg',
          "qrOptions": {
            "typeNumber": 0,
            "mode": "Byte",
            "errorCorrectionLevel": "Q"
          },
          "imageOptions": {
            "crossOrigin": "anonymous",
            "saveAsBlob": true,
            "hideBackgroundDots": true,
            "imageSize": 0.4,
            "margin": 0
          },
          "dotsOptions": {
            "type": "extra-rounded",
            "color": "#1a1a1c",
          },
          "backgroundOptions": {
            "round": 0,
            "color": "#ffffff"
          },
          "cornersSquareOptions": {
            "type": "dot",
            "color": "#000000"
          },
          "cornersDotOptions": {
            "type": "dot",
            "color": "#000000"
          },
        });

        const qrblob = await qrCode.getRawData('svg')
        const dataurl = await svgBlobToDataURL(qrblob)

        resolve(dataurl)
      } catch (err) {
        reject(err)
      }
    })
  }

  async function svgBlobToDataURL(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function() {
        resolve(reader.result);
      };

      reader.onerror = function(error) {
        reject(error);
      };

      reader.readAsDataURL(blob);
    });
  }

  const [referralErrors, setReferralErrors] = useState({
    firstName: false,
    lastName: false,
    email: false
  })

  const [affiliateErrors, setAffiliateErrors] = useState({
    affiliateName: false,
    email: false
  })

  const [generatedAffiliateLink, setGeneratedAffiliateLink] = useState('')


  const [planFields, setPlanFields] = useState<any>({
    planName: '',
    planDescription: '',
    planFeatures: [],
    monthlyPrice: 0,
    yearlyPrice: 0
  })

  const [planErrors, setPlanErrors] = useState({
    planName: false,
    planDescription: false,
    monthlyPrice: false
  })

  const [isCreatingPlan, setIsCreatingPlan] = useState(false)
  const [isCreatingOfferCode, setIsCreatingOfferCode] = useState(false)
  const [isCreatingAffiliate, setIsCreatingAffiliate] = useState(false)

  const [offerCodeFields, setOfferCodeFields] = useState<any>({
    id: '',
    max_redemptions: 0,
    allow_in_checkout: false,
    product_discount: 0,
    product_discount_is_percent: true,
    subscription_discount: 0,
    subscription_discount_is_percent: true,
    valid_start:0,
    valid_end:0,
    cycles:0,
    trial_days:0,
    is_live: true,
  })
  const [offerCodeErrors, setOfferCodeErrors] = useState({
    id: false,

  })

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      const form = e.target.form
      const index = Array.prototype.indexOf.call(form, e.target)
      if (form.elements[index + 1]){
        form.elements[index + 1].focus()
      }
    }
  }

  const handleLimitRedemptions = () => {
    const value = offerCodeFields.max_redemptions
    if (value > 0) {
      setOfferCodeFields({ ...offerCodeFields, ['max_redemptions']: 0 })
    }else{
      setOfferCodeFields({ ...offerCodeFields, ['max_redemptions']: 100 })
    }
  }

  // function formatDateTimeForInput(datetimeString) {
  //   // Convert the ISO datetime string to a JavaScript Date object
  //   const date = new Date(datetimeString);

  //   // Extract the necessary components
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const hours = String(date.getHours()).padStart(2, '0');
  //   const minutes = String(date.getMinutes()).padStart(2, '0');

  //   // Combine into the required format for datetime-local
  //   return `${year}-${month}-${day}T${hours}:${minutes}`;
  // }


  const handleLimitDates = (type:string) => {
    const now = new Date();

    if (type === 'start') {
      const value = offerCodeFields?.valid_start || 0;

      if (value > 0){
        setOfferCodeFields({ ...offerCodeFields, ['valid_start']: 0 })
      }else{
        // const utcNow = now.toISOString(); //not used
        const nowMillis = now.getTime();
        console.log('nowMillis', nowMillis)
        console.log('millistoDate', millistoDate(nowMillis))
        setOfferCodeFields({ ...offerCodeFields, ['valid_start']: nowMillis })
      }
      // setLimitStartDate(!value) //not used
     } else if (type === 'end') {
      const value = offerCodeFields?.valid_end || 0;
      now.setMonth(now.getMonth() + 1);
      // const utcOneMonthFromNow = now.toISOString(); //not used
      const nowMillis = now.getTime();
      setLimitEndDate(!limitEndDate)
      if (value){
        setOfferCodeFields({ ...offerCodeFields, ['valid_end']: 0 })
      }else{
        setOfferCodeFields({ ...offerCodeFields, ['valid_end']: nowMillis })
      }
    }
  }

  const handleAllowCheckout = () => {
    let ocf = {...offerCodeFields}
    ocf.allow_in_checkout = !offerCodeFields.allow_in_checkout;
    setOfferCodeFields(ocf)
  }

  const handleAddTrial = () => {
    let ocf = {...offerCodeFields}
    ocf.trial_days = offerCodeFields.trial_days > 0 ? 0 : 7;
    setOfferCodeFields(ocf)
  }



  const handleAddProductDiscount = () => {
    let ocf = {...offerCodeFields}
    if (offerCodeFields.product_discount > 0) {
      ocf.product_discount = 0
    }else{
      ocf.product_discount = 10
      ocf.product_discount_is_percent = true
      setProductDiscountType('percentage')
    }
    setOfferCodeFields(ocf)
  }

  const handleAddSubscriptionDiscount = () => {
    let ocf = {...offerCodeFields}
    if (offerCodeFields.subscription_discount > 0) {
      ocf.subscription_discount = 0
      ocf.cycles = 0
    }else{
      ocf.subscription_discount = 10
      ocf.subscription_discount_is_percent = true
      ocf.cycles = 6
      setSubscriptionDiscountType('percentage')
    }
    setOfferCodeFields(ocf)
  }


  const handleChangeDiscountType = (e: any, type:string) => {
    const value = e.target.value
    let is_percent = true
    if (value !== 'percentage') {
      is_percent = false
    }
    if (type === 'product') {
      setOfferCodeFields({ ...offerCodeFields, ['product_discount_is_percent']: is_percent })
      setProductDiscountType(value)
    }else if (type === 'subscription') {
      setOfferCodeFields({ ...offerCodeFields, ['subscription_discount_is_percent']: is_percent })
      setSubscriptionDiscountType(value)
    }
  }

  const handleStartDateChange = (e: any) => {
    const date = new Date(e.target.value);
    setOfferCodeFields({ ...offerCodeFields, ['valid_start']: date.getTime() })
  }

  const handleEndDateChange = (e: any) => {
    const date = new Date(e.target.value);
    setOfferCodeFields({ ...offerCodeFields, ['valid_end']: date.getTime() })
  }

  const handleChangeReferral = (e: any) => {
    const value = e.target.value
    setReferralFields({ ...referralFields, [e.target.id]: value })
  }

  const handleChangeOfferCode = (e: any) => {
    const value = e.target.value
    setOfferCodeFields({ ...offerCodeFields, [e.target.id]: value })
  }

  const handleChangeAffiliate = (e: any) => {
    const value = e.target.value
    setAffiliateFields({ ...affiliateFields, [e.target.id]: value })
  }

  const handleAffiliateCommissionType = (type: string) => {
    setAffiliateCommissionType(type)
    setAffiliateFields({ 
      ...affiliateFields, 
      commissionIsPercent: type === 'percentage'
    })
  }

  const handleCustomPlansChange = (planId: string) => {
    const currentPlans = affiliateFields.customPlans || []
    let updatedPlans
    
    if (currentPlans.includes(planId)) {
      // Remove if already selected
      updatedPlans = currentPlans.filter((id: string) => id !== planId)
    } else {
      // Add if not selected
      updatedPlans = [...currentPlans, planId]
    }
    
    setAffiliateFields({ ...affiliateFields, customPlans: updatedPlans })
  }

  const handleStandardPlansToggle = () => {
    setAffiliateFields({ 
      ...affiliateFields, 
      includeStandardPlans: !affiliateFields.includeStandardPlans 
    })
  }

  const handleChangePlan = (e: any) => {
    const value = e.target.value
    setPlanFields({ ...planFields, [e.target.id]: value })
  }

  const handlePlanFeaturesChange = (e: any) => {
    const value = e.target.value
    const isChecked = e.target.checked
    let newFeatures = [...planFields.planFeatures]
    
    if (isChecked) {
      newFeatures.push(value)
    } else {
      newFeatures = newFeatures.filter(feature => feature !== value)
    }
    
    setPlanFields({ ...planFields, planFeatures: newFeatures })
  }

  const copyToClipboard = async (text: string, type: string) => {
    try {
      await navigator.clipboard.writeText(text)
      // Use generatePopup for better UX instead of alert
      generatePopup('success', `${type} copied to clipboard!`)
    } catch (err) {
      console.error('Failed to copy text: ', err)
      // Fallback for older browsers
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
        generatePopup('success', `${type} copied to clipboard!`)
      } catch (fallbackErr) {
        console.error('Fallback: Failed to copy text: ', fallbackErr)
        generatePopup('error', 'Failed to copy to clipboard')
      }
      document.body.removeChild(textArea)
    }
  }


  const handleSave = async () => {
    let errors: any = {}
    if (modalType === 'referrals') {

      if (referralFields.firstName === '') {
        errors.firstName = true
      }

      if (referralFields.lastName === '') {
        errors.lastName = true
      }

      const isemailValid = validateEmail(referralFields.email)
      if (!isemailValid) {
        errors.email = true
      }

      setReferralErrors(errors)
      if (Object.keys(errors).length === 0) {

        setModalType('')
      } else {
        setModalType('referrals')
      }
    }else if (modalType === 'offercodes') {
      if (offerCodeFields.id === '') {
        errors.id = true
      }

      setOfferCodeErrors(errors)
      if (Object.keys(errors).length === 0) {
        setIsCreatingOfferCode(true)
        try {
          const result = await dispatch(addOfferCode({
            id: offerCodeFields.id,
            max_redemptions: offerCodeFields.max_redemptions,
            allow_in_checkout: offerCodeFields.allow_in_checkout,
            product_discount: offerCodeFields.product_discount,
            product_discount_is_percent: offerCodeFields.product_discount_is_percent,
            subscription_discount: offerCodeFields.subscription_discount,
            subscription_discount_is_percent: offerCodeFields.subscription_discount_is_percent,
            valid_start: offerCodeFields.valid_start,
            valid_end: offerCodeFields.valid_end,
            cycles: offerCodeFields.cycles,
            trial_days: offerCodeFields.trial_days,
            is_live: offerCodeFields.is_live
          }))
          
          if (result?.offerCodeId) {
            setModalType('')
            // Refresh offer codes list
            await dispatch(getAllOfferCodes({}))
          }
        } catch (error) {
          console.error('Error creating offer code:', error)
        } finally {
          setIsCreatingOfferCode(false)
        }
      } else {
        setModalType('offercodes')
      }
    } else if (modalType === 'affiliates') {
      if (affiliateFields.affiliateName === '') {
        errors.affiliateName = true
      }

      const isemailValid = validateEmail(affiliateFields.email)
      if (!isemailValid) {
        errors.email = true
      }

      setAffiliateErrors(errors)
      if (Object.keys(errors).length === 0) {
        setIsCreatingAffiliate(true)
        try {
          const result = await dispatch(addAffiliate({
            affiliateName: affiliateFields.affiliateName,
            email: affiliateFields.email,
            offerCode: affiliateFields.offerCode || null,
            customPlans: affiliateFields.customPlans || [],
            includeStandardPlans: affiliateFields.includeStandardPlans,
            commissionRate: affiliateFields.commissionRate || 0,
            commissionIsPercent: affiliateFields.commissionIsPercent
          }))
          
          if (result?.affiliateLink) {
            setGeneratedAffiliateLink(result.affiliateLink)
            // Don't close modal yet - show the generated link
          } else {
            setModalType('')
            // Refresh affiliates list
            await dispatch(getAllAffiliates({}))
          }
        } catch (error) {
          console.error('Error creating affiliate:', error)
        } finally {
          setIsCreatingAffiliate(false)
        }
      } else {
        setModalType('affiliates')
      }
    } else if (modalType === 'plans') {
      if (planFields.planName === '') {
        errors.planName = true
      }

      if (planFields.planDescription === '') {
        errors.planDescription = true
      }

      if (planFields.monthlyPrice <= 0) {
        errors.monthlyPrice = true
      }

      setPlanErrors(errors)
      if (Object.keys(errors).length === 0) {
        setIsCreatingPlan(true)
        try {
          const result = await dispatch(addCustomPlan({
            planName: planFields.planName,
            planDescription: planFields.planDescription,
            planFeatures: planFields.planFeatures,
            monthlyPrice: planFields.monthlyPrice,
            yearlyPrice: planFields.yearlyPrice || 0
          }))
          
          if (result?.planId) {
            setModalType('')
            // Refresh custom plans list
            await dispatch(getAllCustomPlans({}))
          }
        } catch (error) {
          console.error('Error creating plan:', error)
        } finally {
          setIsCreatingPlan(false)
        }
      } else {
        setModalType('plans')
      }
    }
  }

  useEffect(() => {
    const getdata = async () => {
      setIsLoading(true);
      await dispatch(getAllUser({}))
      await dispatch(getAllReferrals({}))
      await dispatch(getAllAffiliates({}))
      await dispatch(getAllCustomPlans({}))
      await dispatch(getPlanFeatures())

      await dispatch(getAllOfferCodes({}))
      console.log('referrals', referrals)
      console.log('users', users)
      console.log('affiliates', affiliates)
      console.log('offercodes', offerCodes)
      setIsLoading(false);
      //console.log('testmode', testmode)
    }
    getdata();
  }, []);

  useEffect(() => {
    console.log ('offerCodes', offerCodes)
  }, [offerCodes]);


  const handleReferral = async (type, action, itemids = []) => {
    if (type === 'users' && action === 'mimic') {
        try {
            await dispatch(adminSwitchToAccount({targetAccountId: itemids[0]}))
            window.location.href = '/dashboard'
        } catch (error) {
            console.error('Failed to switch to account:', error)
        }
    }

    if (action === 'create') {
      setModalType(type)
      // Reset generated link when opening new affiliate modal
      if (type === 'affiliates') {
        setGeneratedAffiliateLink('')
      }
    }

    if (action === 'copyLink' && type === 'affiliates' && itemids.length > 0) {
      // Copy affiliate link to clipboard
      const affiliate = affiliates.find((aff: any) => aff.id === itemids[0])
      if (affiliate?.affiliateLink) {
        await copyToClipboard(affiliate.affiliateLink, 'Affiliate link')
      }
    }

    console.log('type', type, 'action', action, 'itemids', itemids)
    //await dispatch(updateReferral({ id, status }))
  }

  const handleProductionMode = async () => {
    window.location.href = ngrokip + '?testmode=production';
  }

  const handleStagingMode = async () => {
    window.location.href = ngrokip +  '?testmode=staging';
  }

  const handleProductionQR = async () => {
    const url = ngrokip + '?testmode=production';
    let qrdata:any = await makeQrcode(url)
    setCurrQr(qrdata)
  }

  const handleStagingQR = async () => {
    const url = ngrokip +  '?testmode=staging';
    let qrdata:any = await makeQrcode(url)
    setCurrQr(qrdata)
  }

  const handleLocalMode = async () => {
    localStorage.setItem('testmode', '')
    window.location.href = 'http://localhost:3000'
  }



  return (
    <>
    <div style={{margin:'20px'}}>
     <h1 >Administration Tools</h1>
     {ngrokip && (<div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px', position:'relative'}}>
      <h3 style={{marginBottom:'10px'}}>Dev Tools</h3>
      {testmode === 'production' ? (
        <>
        <button style={{padding:'10px', backgroundColor:'red', color:'white', border:'none', marginRight:'10px'}} onClick={handleStagingMode}>Test in Staging</button>
        <button style={{padding:'10px', backgroundColor:'red', color:'white', border:'none', marginRight:'10px'}} onClick={handleLocalMode}>Test with Local Emulators</button>
        { currQR === '' ? (<button style={{padding:'10px', backgroundColor:'black', color:'white', border:'none', marginRight:'10px'}} onClick={handleProductionQR}>Generate Production QR</button>
        ):(
          <img src={currQR} alt='qr code' style={{width:'100px', height:'100px',top:'-40px', position:'absolute'}} />
        )

      }
        </>
      ) : testmode === 'staging' ? (
        <>
        <button style={{padding:'10px', backgroundColor:'red', color:'white', border:'none', marginRight:'10px'}} onClick={handleProductionMode}>Test in Production</button>
        <button style={{padding:'10px', backgroundColor:'red', color:'white', border:'none', marginRight:'10px'}} onClick={handleLocalMode}>Test with Local Emulators</button>
        {
        currQR === '' ? (
        <button style={{padding:'10px', backgroundColor:'black', color:'white', border:'none', marginRight:'10px'}} onClick={handleStagingQR}>Generate Staging QR</button>
        ):(
          <img src={currQR} alt='qr code' style={{width:'100px', height:'100px',top:'-40px', position:'absolute'}} />
        )
        }
        </>
      ):(
        <>
        <button style={{padding:'10px', backgroundColor:'red', color:'white', border:'none', marginRight:'10px'}} onClick={handleProductionMode}>Test in Production</button>
        <button style={{padding:'10px', backgroundColor:'red', color:'white', border:'none'}} onClick={handleStagingMode}>Test in Staging</button>
        </>
      )}

      </div>)}
     <div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px'}}>
     <h3 style={{marginBottom:'10px'}}>Users</h3>
        <STable
        headers={[
          { column: "email", label: "Email" },
          { column: "id", label: "Id" },
          { column: "name", label: "Name" },
          { column: "type", label: "User Type" },
          { column: "status", label: "Status" }
        ]}
        data={users || []}
        isLoading={isLoading}
        loadingTag={<h1>Loading...</h1>}
        handleReferral={handleReferral}
        type='users'
      />
</div>
<div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px'}}>
<h3 style={{marginBottom:'10px'}}>B2B Accounts</h3>
        <B2BAccountsTable />
</div>
<div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px'}}>
<h3 style={{marginBottom:'10px'}}>Referrals</h3>
        <STable
        headers={[
          { column: "email", label: "Email" },
          { column: "id", label: "Id" },
          { column: "name", label: "Name" },
          { column: "referred_by", label: "Referred By" },
          { column: "offer_code", label: "Offer Code" },
          { column: "status", label: "Status" }
        ]}
        data={referrals}
        isLoading={isLoading}
        loadingTag={<h1>Loading...</h1>}
        handleReferral={handleReferral}
        type='referrals'
      />
</div>
<div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px'}}>
<h3 style={{marginBottom:'10px'}}>Affiliates</h3>
        <STable
        headers={[
          { column: "affiliateName", label: "Affiliate Name" },
          { column: "email", label: "Email" },
          { column: "offerCode", label: "Offer Code" },
          { column: "siteVisits", label: "Site Visits" },
          { column: "accountsCreated", label: "Accounts Created" },
          { column: "affiliateLink", label: "Affiliate Link" }
        ]}
        data={affiliates || []}
        isLoading={isLoading}
        loadingTag={<h1>Loading...</h1>}
        handleReferral={handleReferral}
        type='affiliates'
      />
</div>
<div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px'}}>

<h3 style={{marginBottom:'10px'}}>Offer Codes</h3>
        <STable
        headers={[
          { column: "id", label: "Offer Code" },
          { column: "type", label: "Type" },
          { column: "limit", label: "Redemptions Left" },
          { column: "allow_in_checkout", label: "Redeemable at Checkout" },
          { column: "product_discount", label: "Product Discount" },
          { column: "subscription_discount", label: "Subscription Discount" },
          { column: "length", label: "Days Applicable" },
          { column: "expiration", label: "Expiration" },
          { column: "status", label: "Live" },
          { column: "stripeCouponId", label: "Stripe Coupon" }
        ]}
        data={offerCodes || []}
        isLoading={isLoading}
        loadingTag={<h1>Loading...</h1>}
        handleReferral={handleReferral}
        type='offercodes'
      />
      </div>
<div style={{border:'1px, solid, black', padding:'15px', marginBottom:'15px'}}>
<h3 style={{marginBottom:'10px'}}>Custom Plans</h3>
        <STable
        headers={[
          { column: "planName", label: "Plan Name" },
          { column: "planDescription", label: "Description" },
          { column: "monthlyPrice", label: "Monthly Price" },
          { column: "yearlyPrice", label: "Yearly Price" },
          { column: "planFeatures", label: "Features" }
        ]}
        data={customPlans || []}
        isLoading={isLoading}
        loadingTag={<h1>Loading...</h1>}
        handleReferral={handleReferral}
        type='plans'
      />
</div>
    </div>
    <Modal show={modalType !== ''} style={{zIndex:10000}} onHide={(isCreatingPlan || isCreatingOfferCode || isCreatingAffiliate) ? () => {} : handleClose}>
        <Modal.Header closeButton={!(isCreatingPlan || isCreatingOfferCode || isCreatingAffiliate)}>
          <Modal.Title>{modalType === 'referrals' ? 'Invite a User' : modalType === 'offercodes' ? 'Add An Offer Code' : modalType === 'affiliates' ? 'Add An Affiliate' : modalType === 'plans' ? 'Create Custom Plan' : '' }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form style={{zIndex:10000}}>
          {modalType === 'referrals' ? (
            <>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='firstName'>First Name*</label>
                  <input
                    type='text'
                    onChange={(e: any) => handleChangeReferral(e)}
                    value={referralFields.firstName}
                    className='form-control'
                    id='firstName'
                    aria-describedby='fnhelp'
                    placeholder='Enter First Name'
                    onKeyDown={handleKeyDown}
                  />
                  {referralErrors.firstName && (
                    <small id='fnhelp' style={{ color: 'red' }} className='form-text'>
                      First Name is required
                    </small>
                  )}
                </div>
              </div>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='lastName'>Last Name*</label>
                  <input
                    type='text'
                    onChange={(e: any) => handleChangeReferral(e)}
                    value={referralFields.lastName}
                    className='form-control'
                    id='lastName'
                    aria-describedby='lnhelp'
                    placeholder='Enter Last Name'
                    onKeyDown={handleKeyDown}
                  />
                  {referralErrors.lastName && (
                    <small id='lnhelp' style={{ color: 'red' }} className='form-text'>
                      Last Name is required
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='email'>Email*</label>
                  <input
                    type='email'
                    onChange={(e: any) => handleChangeReferral(e)}
                    value={referralFields.email}
                    className='form-control'
                    id='email'
                    aria-describedby='emailHelp'
                    placeholder='Enter Email'
                    onKeyDown={handleKeyDown}
                  />
                  {referralErrors.email && (
                    <small id='emailHelp' style={{ color: 'red' }} className='form-text'>
                      Enter a valid email address
                    </small>
                  )}
                </div>
              </div>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='email'>Offer Code</label>
                  <select
                    onChange={(e: any) => handleChangeReferral(e)}
                    name="offer_code"
                    id="offer_code"
                    value={referralFields.offer_code}
                    className='form-control'
                    onKeyDown={handleKeyDown}
                  >
                    <option value="">No Offer Code</option>
                    <option value="beta">beta</option>
                    <option value="advanced">advanced</option>
                    <option value="creator">creator</option>
                    { offerCodes.map((item: any) => (
                      <option key={item.id} value={item.id}>{item.id}</option>
                    ))}
                  </select><br></br>
                </div>
              </div>
            </div>
            </>
          ) : modalType === 'offercodes' ? (
            <>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='firstName'>Offer Code ID* (Must be unique i.e. TWENTY%OFF)</label>
                  <input
                    type='text'
                    onChange={(e: any) => handleChangeOfferCode(e)}
                    value={offerCodeFields.id}
                    className='form-control'
                    id='id'
                    aria-describedby='fnhelp'
                    placeholder='Enter Offer Code ID'
                    onKeyDown={handleKeyDown}
                  />
                  {offerCodeErrors.id && (
                    <small id='fnhelp' style={{ color: 'red' }} className='form-text'>
                      Offer Code ID is Required
                    </small>
                  )}
                </div>
              </div>
              <div className='row' style={{borderBottom:'1px solid black'}}>
           <h3 style={{marginBottom:'10px',textAlign:'center'}}>Subscriptions</h3>
              </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <Checkbox isChecked={offerCodeFields?.trial_days > 0} text='Enable Trial Period' doCheck={() => handleAddTrial()} />
                </div>
              </div>
              </div>
              {
                offerCodeFields.trial_days > 0 && (
                  <div className='row'>
                    <div className='col-sm'>
                      <div className='form-group mb-3'>
                        <label htmlFor='trial_days'>Number of days for free trial before charging.</label>
                        <input
                          type='number'
                          onChange={(e: any) => handleChangeOfferCode(e)}
                          value={offerCodeFields.trial_days}
                          min={0}
                          className='form-control'
                          id='trial_days'
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                    </div>
                  </div>
                )
              }

<div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <Checkbox isChecked={offerCodeFields.subscription_discount > 0} text='Subscription Discount' doCheck={handleAddSubscriptionDiscount} />
                </div>
              </div>
              </div>
              { offerCodeFields.subscription_discount > 0 && (
                <>
                <div className='row'>
                  <div className='col-sm'>
                    <div className='form-group mb-3'>
                      <label htmlFor='subscription_discount_is_percent'>Subscription Discount Type</label>
                      <select
                        onChange={(e: any) => handleChangeDiscountType(e, 'subscription')}
                        name="subscription_discount_type"
                        id="subscription_discount_type"
                        value={subscriptionDiscountType}
                        className='form-control'
                        onKeyDown={handleKeyDown}
                        >
                        <option value="percentage">Percentage</option>
                        <option value="flat">Flat</option>
                      </select><br></br>
                    </div>
                  </div>
                  <div className='col-sm'>
                    <div className='form-group mb-3'>
                      <label htmlFor='subscription_discount'>Subscription Discount in {subscriptionDiscountType === 'percentage' ? '%' : '$'}</label>
                      <input
                        type='number'
                        onChange={(e: any) => handleChangeOfferCode(e)}
                        value={offerCodeFields.subscription_discount}
                        min={0}
                        max={offerCodeFields.subscription_discount_is_percent ? 100 : 19.99}
                        className='form-control'
                        id='subscription_discount'
                        onKeyDown={handleKeyDown}
                      />
                    </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='cycles'>Number of subscription cycles to discount.</label>
                  <input
                    type='number'
                    onChange={(e: any) => handleChangeOfferCode(e)}
                    value={offerCodeFields.cycles}
                    min={0}
                    className='form-control'
                    id='cycles'
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>
                </>
          )}


            </div>
            <div className='row' style={{borderBottom:'1px solid black'}}>
           <h3 style={{marginBottom:'10px',textAlign:'center'}}>Products</h3>
              </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <Checkbox isChecked={offerCodeFields.product_discount > 0} text='Discount Products' doCheck={handleAddProductDiscount} />
                </div>
              </div>
              </div>
           { offerCodeFields.product_discount > 0 && ( <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='product_discount_is_percent'>Product Discount Type</label>
                  <select
                    onChange={(e: any) => handleChangeDiscountType(e, 'product')}
                    name="product_discount_type"
                    id="product_discount_type"
                    value={productDiscountType}
                    className='form-control'
                    onKeyDown={handleKeyDown}
                    >
                    <option value="percentage">Percentage</option>
                    <option value="flat">Flat</option>
                  </select><br></br>
                </div>
              </div>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='product_discount'>Product Discount in {productDiscountType === 'percentage' ? '%' : '$'}</label>
                  <input
                    type='number'
                    onChange={(e: any) => handleChangeOfferCode(e)}
                    value={offerCodeFields.product_discount}
                    min={0}
                    max={offerCodeFields.product_discount_is_percent ? 100 : undefined}
                    className='form-control'
                    id='product_discount'
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>
            </div>)}
           



            <div className='row' style={{borderBottom:'1px solid black'}}>
           <h3 style={{marginBottom:'10px',textAlign:'center'}}>Common</h3>
              </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <Checkbox isChecked={offerCodeFields?.valid_start > 0} text='Set start date' doCheck={() => handleLimitDates('start')} />
                </div>
              </div>
              </div>
              { offerCodeFields?.valid_start > 0 && (
              <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                <label htmlFor='valid_start'>Offer Code is Valid At</label>
                  <input
                    type="datetime-local"
                     className='form-control'
                    id="valid_start"
                    value={millistoDatetimeLocal(offerCodeFields?.valid_start)}
                    onChange={handleStartDateChange}
                    min={millistoDatetimeLocal(new Date().getTime())}
                  />
                </div>
              </div>
              </div>
              )}
              <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <Checkbox isChecked={offerCodeFields?.valid_end > 0} text='Set end date' doCheck={() => handleLimitDates('end')} />
                </div>
              </div>
              </div>
              { offerCodeFields?.valid_end > 0 && (
              <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                <label htmlFor='valid_end'>Offer Code is Valid Until</label>
                  <input
                    type="datetime-local"
                     className='form-control'
                    id="valid_end"
                    value={millistoDatetimeLocal(offerCodeFields?.valid_end)}
                    onChange={handleEndDateChange}
                    min={offerCodeFields?.valid_start > 0 ? millistoDatetimeLocal(offerCodeFields?.valid_start) : millistoDatetimeLocal(new Date().getTime())}
                  />
                </div>
              </div>
              </div>
              )}
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <Checkbox isChecked={offerCodeFields.max_redemptions > 0} text='Limit Redemptions' doCheck={handleLimitRedemptions} />
                </div>
              </div>
              </div>
              { offerCodeFields.max_redemptions > 0 && (<div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='lastName'>Maximum Redemptions Allowed</label>
                  <input
                    type='number'
                    onChange={(e: any) => handleChangeOfferCode(e)}
                    value={offerCodeFields.max_redemptions}
                    min={0}
                    className='form-control'
                    id='max_redemptions'
                    onKeyDown={handleKeyDown}
                  />
                </div>
              </div>)}
            <div className='row'>
            <div className='col-sm'>
                <div className='form-group mb-3'>
                <Checkbox isChecked={offerCodeFields?.allow_in_checkout} text='Allow Code to be used In Checkout Forms' doCheck={handleAllowCheckout} />
                </div>
              </div>
            </div>

            </>
          ) : modalType === 'affiliates' ? (
            <>
            {generatedAffiliateLink ? (
              // Show generated link after successful creation
              <>
              <div className='row'>
                <div className='col-sm'>
                  <div className='form-group mb-3'>
                    <h5 style={{color: 'green', marginBottom: '20px'}}>✅ Affiliate Created Successfully!</h5>
                    <label><strong>Generated Affiliate Link:</strong></label>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px',
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '4px',
                      marginTop: '5px'
                    }}>
                      <input
                        type='text'
                        value={generatedAffiliateLink}
                        className='form-control'
                        readOnly
                        style={{ border: 'none', backgroundColor: 'transparent' }}
                      />
                      <button
                        type='button'
                        className='btn btn-sm btn-primary'
                        onClick={() => copyToClipboard(generatedAffiliateLink, 'Affiliate link')}
                      >
                        Copy
                      </button>
                    </div>
                    <small className='form-text text-muted'>
                      The affiliate has been notified via email with their link and instructions.
                    </small>
                  </div>
                </div>
              </div>
              </>
            ) : (
              // Show form for creating new affiliate
              <>
              <div className='row'>
                <div className='col-sm'>
                  <div className='form-group mb-3'>
                    <label htmlFor='affiliateName'>Affiliate Name*</label>
                    <input
                      type='text'
                      onChange={(e: any) => handleChangeAffiliate(e)}
                      value={affiliateFields.affiliateName}
                      className='form-control'
                      id='affiliateName'
                      aria-describedby='affiliateNameHelp'
                      placeholder='Enter Affiliate Name'
                      onKeyDown={handleKeyDown}
                    />
                    {affiliateErrors.affiliateName && (
                      <small id='affiliateNameHelp' style={{ color: 'red' }} className='form-text'>
                        Affiliate Name is required
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm'>
                  <div className='form-group mb-3'>
                    <label htmlFor='email'>Email*</label>
                    <input
                      type='email'
                      onChange={(e: any) => handleChangeAffiliate(e)}
                      value={affiliateFields.email}
                      className='form-control'
                      id='email'
                      aria-describedby='emailHelp'
                      placeholder='Enter Email'
                      onKeyDown={handleKeyDown}
                    />
                    {affiliateErrors.email && (
                      <small id='emailHelp' style={{ color: 'red' }} className='form-text'>
                        Enter a valid email address
                      </small>
                    )}
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm'>
                  <div className='form-group mb-3'>
                    <label htmlFor='offerCode'>Offer Code (Optional)</label>
                    <select
                      onChange={(e: any) => handleChangeAffiliate(e)}
                      name="offerCode"
                      id="offerCode"
                      value={affiliateFields.offerCode}
                      className='form-control'
                      onKeyDown={handleKeyDown}
                    >
                      <option value="">No Offer Code</option>
                      <option value="beta">beta</option>
                      <option value="advanced">advanced</option>
                      <option value="creator">creator</option>
                      { offerCodes.map((item: any) => (
                        <option key={item.id} value={item.id}>{item.id}</option>
                      ))}
                    </select><br></br>
                    <small className='form-text text-muted'>
                      Users who sign up through this affiliate link will automatically receive the selected offer code.
                    </small>
                  </div>
                </div>
              </div>

              {/* Custom Plans Selection */}
              <div className='row'>
                <div className='col-sm'>
                  <div className='form-group mb-3'>
                    <label>Custom Plans (Optional)</label>
                    <div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ced4da', borderRadius: '4px', padding: '10px' }}>
                      {customPlans.length === 0 ? (
                        <small className='text-muted'>No custom plans available</small>
                      ) : (
                        customPlans.map((plan: any) => (
                          <div key={plan.id} className='form-check'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id={`customPlan_${plan.id}`}
                              checked={affiliateFields.customPlans.includes(plan.id)}
                              onChange={() => handleCustomPlansChange(plan.id)}
                            />
                            <label className='form-check-label' htmlFor={`customPlan_${plan.id}`} style={{ color: '#212529' }}>
                              <strong style={{ color: '#000' }}>{plan.planName}</strong> - <span style={{ color: '#28a745', fontWeight: '600' }}>{plan.monthlyPrice}</span>
                              {plan.yearlyPrice && plan.yearlyPrice !== 'Not Set' && (
                                <span style={{ color: '#17a2b8', fontWeight: '500', marginLeft: '8px' }}>
                                  | {plan.yearlyPrice}/year
                                </span>
                              )}
                              <br />
                              <small style={{ color: '#495057' }}>{plan.planDescription}</small>
                            </label>
                          </div>
                        ))
                      )}
                    </div>
                    <small className='form-text text-muted'>
                      Select which custom plans this affiliate can promote.
                    </small>
                  </div>
                </div>
              </div>

              {/* Include Standard Plans Switch - Only show if custom plans are selected */}
              {affiliateFields.customPlans && affiliateFields.customPlans.length > 0 && (
                <div className='row'>
                  <div className='col-sm'>
                    <div className='form-group mb-3'>
                      <div className='form-check form-switch'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          id='includeStandardPlans'
                          checked={affiliateFields.includeStandardPlans}
                          onChange={handleStandardPlansToggle}
                        />
                        <label className='form-check-label' htmlFor='includeStandardPlans' style={{ color: '#212529' }}>
                          <strong style={{ color: '#000' }}>Include Standard Plans</strong>
                        </label>
                      </div>
                      <small className='form-text' style={{ color: '#495057' }}>
                        Allow this affiliate to also promote standard subscription plans in addition to the selected custom plans.
                      </small>
                    </div>
                  </div>
                </div>
              )}

              {/* Commission Rate */}
              <div className='row'>
                <div className='col-sm'>
                  <div className='form-group mb-3'>
                    <label htmlFor='commissionRate'>Commission Rate</label>
                    <div className='input-group'>
                      <div className='input-group-prepend'>
                        <select 
                          className='form-select' 
                          value={affiliateCommissionType} 
                          onChange={(e) => handleAffiliateCommissionType(e.target.value)}
                          style={{ borderTopRightRadius: '0', borderBottomRightRadius: '0' }}
                        >
                          <option value="percentage">%</option>
                          <option value="flat">$</option>
                        </select>
                      </div>
                      <input
                        type='number'
                        onChange={(e: any) => handleChangeAffiliate(e)}
                        value={affiliateFields.commissionRate}
                        className='form-control'
                        id='commissionRate'
                        placeholder={affiliateCommissionType === 'percentage' ? 'Enter percentage (e.g., 10)' : 'Enter amount (e.g., 25.00)'}
                        step={affiliateCommissionType === 'percentage' ? '1' : '0.01'}
                        min='0'
                        max={affiliateCommissionType === 'percentage' ? '100' : undefined}
                      />
                    </div>
                    <small className='form-text text-muted'>
                      {affiliateCommissionType === 'percentage' 
                        ? 'Percentage commission from each sale (0-100%)' 
                        : 'Flat commission amount per sale in USD'}
                    </small>
                  </div>
                </div>
              </div>
              </>
            )}
            
            {/* Add Affiliate Button for affiliate modal */}
            {!generatedAffiliateLink && (
              <div className="d-flex justify-content-end mt-3">
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={() => handleSave()}
                  disabled={isCreatingAffiliate}
                >
                  {isCreatingAffiliate ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Creating Affiliate...
                    </>
                  ) : (
                    'Add Affiliate'
                  )}
                </button>
              </div>
            )}
            </>
          ) : modalType === 'plans' ? (
            <>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='planName'>Plan Name*</label>
                  <input
                    type='text'
                    onChange={(e: any) => handleChangePlan(e)}
                    value={planFields.planName}
                    className='form-control'
                    id='planName'
                    aria-describedby='planNameHelp'
                    placeholder='Enter Plan Name'
                    onKeyDown={handleKeyDown}
                  />
                  {planErrors.planName && (
                    <small id='planNameHelp' style={{ color: 'red' }} className='form-text'>
                      Plan Name is required
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='planDescription'>Plan Description*</label>
                  <textarea
                    onChange={(e: any) => handleChangePlan(e)}
                    value={planFields.planDescription}
                    className='form-control'
                    id='planDescription'
                    aria-describedby='planDescriptionHelp'
                    placeholder='Enter Plan Description'
                    rows={3}
                    onKeyDown={handleKeyDown}
                  />
                  {planErrors.planDescription && (
                    <small id='planDescriptionHelp' style={{ color: 'red' }} className='form-text'>
                      Plan Description is required
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label>Plan Features</label>
                  {Object.entries(planFeatures).map(([key, feature]: [string, any]) => (
                    <div key={key} className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        value={key}
                        id={`feature_${key}`}
                        checked={planFields.planFeatures.includes(key)}
                        onChange={handlePlanFeaturesChange}
                      />
                      <label className='form-check-label' htmlFor={`feature_${key}`}>
                        <strong>{feature.name}</strong> - {feature.description}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='monthlyPrice'>Monthly Price ($)*</label>
                  <input
                    type='number'
                    onChange={(e: any) => handleChangePlan(e)}
                    value={planFields.monthlyPrice}
                    min={0}
                    step={0.01}
                    className='form-control'
                    id='monthlyPrice'
                    placeholder='19.99'
                    onKeyDown={handleKeyDown}
                  />
                  {planErrors.monthlyPrice && (
                    <small style={{ color: 'red' }} className='form-text'>
                      Monthly Price is required and must be greater than 0
                    </small>
                  )}
                </div>
              </div>
              <div className='col-sm'>
                <div className='form-group mb-3'>
                  <label htmlFor='yearlyPrice'>Yearly Price ($) - Optional</label>
                  <input
                    type='number'
                    onChange={(e: any) => handleChangePlan(e)}
                    value={planFields.yearlyPrice}
                    min={0}
                    step={0.01}
                    className='form-control'
                    id='yearlyPrice'
                    placeholder='199.99'
                    onKeyDown={handleKeyDown}
                  />
                  <small className='form-text text-muted'>
                    Leave empty if not offering yearly pricing
                  </small>
                </div>
              </div>
            </div>
            </>
          ) : (<></>)}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button 
            onClick={handleClose} 
            className='btn btn-secondary'
            disabled={isCreatingPlan || isCreatingOfferCode}
          >
            Close
          </button>
          {modalType === 'offercodes' && (
            <button 
              onClick={() => handleSave()} 
              className='btn btn-primary'
              disabled={isCreatingOfferCode}
            >
              {isCreatingOfferCode ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Creating Offer Code...
                </>
              ) : (
                'Save'
              )}
            </button>
          )}
          {modalType === 'referrals' && (
            <button 
              onClick={() => handleSave()} 
              className='btn btn-primary'
            >
              Save
            </button>
          )}
          {modalType === 'plans' && (
            <button 
              onClick={() => handleSave()} 
              className='btn btn-primary' 
              disabled={isCreatingPlan}
            >
              {isCreatingPlan ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Creating Plan...
                </>
              ) : (
                'Create Plan'
              )}
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Admintools
